import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';
import { FeatureQrCodeModule } from '@unpispas/feature/qrcode';
import { FeatureFloorModule } from '@unpispas/feature/floor';

import { UppPinpadHomeComponent } from '../components/home/upp-home';
import { UppPinpadWorkComponent } from '../components/work/upp-work';
import { UppPinpadTablesComponent } from '../components/tables/upp-tables';
import { UppPinpadPaychargeComponent } from '../components/paycharge/upp-paycharge';
import { UppPinpadPaymentComponent } from '../components/payment/upp-payment';
import { UppPinpadSelectComponent } from '../components/select/upp-select';
import { UppPinpadSessionComponent } from '../components/session/upp-session';
import { UppPinpadTicketComponent } from '../components/ticket/upp-ticket';

@NgModule({
  declarations: [
    UppPinpadHomeComponent,
    UppPinpadWorkComponent,
    UppPinpadTablesComponent,
    UppPinpadPaychargeComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    UppBaseModule,
    UppWdgtModule,
    UppDataModule,
    FeatureQrCodeModule,
    FeatureFloorModule,
    UppPinpadPaymentComponent,
    UppPinpadSelectComponent,
    UppPinpadSessionComponent,
    UppPinpadTicketComponent,
  ],
  exports: [
    UppPinpadHomeComponent,
    UppPinpadWorkComponent,
    UppPinpadPaymentComponent,
    UppPinpadSelectComponent,
    UppPinpadSessionComponent,
    UppPinpadTicketComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FeaturePinpadModule {}
